module.exports = __webpack_public_path__ + "img/iHealth-AI.8c2896f2.png";